import type { RouteObject } from "react-router";
import { ORDER_SNAPSHOT_SEGMENT } from "@/features/order/order.paths";
import { OrderSnapshot } from "./OrderSnapshot";

export const orderSnapshotRoute: RouteObject = {
  path: ORDER_SNAPSHOT_SEGMENT,
  element: <OrderSnapshot />,
};
